import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { PORT } from "../../config";
import { notify } from "react-notify-toast";
import DeletePopup from "./ConfirmationBox";
import { addDays } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import "./UserProfile.css";
import { getStates, handleLogErrorToSlack } from "../../Helper";
// import $ from "jquery";
import FormField from "../../Components/FormField/FormField";
import FormDropdown from "../../Components/FormField/FormDropdown";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";

//redux
import { connect } from "react-redux";
import { API } from "../../API";
import { CircularProgress } from "@mui/material";

const URL = PORT;
let Countries = [];
const States = getStates();

class VisaForm2 extends React.Component {
  constructor(props) {
    super(props);
    let user = this.props.user;
    if (user === null) {
      window.location = "/login";
    }

    this.state = {
      displayVisaType: user.visa_status === "I am a visa holder",
      issuing_office_options: [],
      visa_file: {
        name: "",
        type: "",
        file: [],
      },
      displayOther: false,
      deletevisaPopup: false,
    };
  }

  uploadDocument = (id) => {
    document.getElementById(id).click();
  };

  componentDidMount = () => {
    //get a complete list of countries
    API.getCountries().then((res) => {
      Countries = res.data;
      this.setState({ issuing_office_options: Countries.sort() });
    });
  };

  //  Validation for file: Checks if file is uploaded, else returns false
  validateFile = (file, filename) => {
    let isValid = false;
    if (file !== null && file !== undefined) {
      isValid = true;
    }
    return isValid;
  };

  onFileUpload = (fileName, url) => {
    this.props.handleStateChange("visa_filename", fileName);
    this.props.handleStateChange("visa_url", url);
  };

  saveFile = async (file, filename) => {
    this.setState({
      isLoading: true
    });
    const fileName = 'visa';

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", `${fileName}`)
      const response = await API.uploadCompressedFileToS3(formData)
  
      const url = response?.data?.data
      const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
      const suffix = url.substring(cut_length, url.length);
      const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
      const new_url = prefix + suffix;
      this.onFileUpload(file.name, new_url);
      this.setState({
        isLoading: false
      });
    } catch (error) {
      this.setState({
        isLoading: false
      });
      handleLogErrorToSlack(error, true);
      notify.show(JSON.stringify(error), "error");
    }
  };

  handleddlChange = (e) => {
    this.props.handleFormFieldChange(e);
    this.setState({ displayOther: e.target.value === "Other" });
  };

  handleRadioChange = (e) => {
    this.props.handleRadioChange(e);
    this.setState({ displayVisaType: e.target.title === "I am a visa holder" });
  };

  // Updates local storage object when any control updates its state
  // updateLocalStorage = (field, value) => {
  // 	let userData = JSON.parse(window.localStorage.getItem("user"));
  // 	userData[`${field}`] = value;
  // 	window.localStorage.setItem("user", JSON.stringify(userData));
  // };

  // setUserState = (event) => {
  // 	let field = event.target.name;
  // 	let value = event.target.value;
  // 	this.state[field] = value;
  // 	this.setState({ user: this.state.user });

  // 	this.updateLocalStorage(field, value);
  // };

  deleteFile = (isDelete, fileName, popupStatus) => {
    // var field = fileName + "_filename";
    var popUpState = "delete" + fileName + "Popup";
    // var buttonID = "btnUpload_" + fileName;
    if (isDelete) {
      notify.show("File deleted successfully");
      // this.setState({ [field]: null });
      // this.setState({ link_style: "none" });
      this.props.handleStateChange("visa_filename", null);
      this.props.handleStateChange("visa_url", null);
      // document.getElementById(buttonID).disabled = false;
    }
    this.setState({ [popUpState]: popupStatus });
  };

  handleVisaFileChange = () => {
    var isValidFile = false;
    let visaFile = this.uploadVisa.files[0];
    let filesize = this.uploadVisa.files[0].size >> 10

    isValidFile = this.validateFile(visaFile, "visa");
    if (isValidFile) {
      this.saveFile(visaFile, "visa");
    }
  };

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="auth-text-top mb-5">
            {/* VISA HOLDER FIELDS */}

            <div id="dvVisaHolder" disabled={this.state.displayVisaType}>
              {/* -----radio----- */}

              <ButtonContainer>
                <CheckableButton
                  id="citizen"
                  name="visa_status"
                  onChange={this.handleRadioChange}
                  checked={
                    this.props.state.visa_status === "I am Australian Citizen"
                  }
                  title="I am Australian Citizen"
                  required
                >
                  {console.log('status', this.props.state.visa_status)}
                  I am a Citizen of Aust./NZ
                </CheckableButton>
                <CheckableButton
                  id="visa_holder"
                  name="visa_status"
                  onChange={this.handleRadioChange}
                  checked={
                    this.props.state.visa_status === "I am a visa holder"
                  }
                  title="I am a visa holder"
                  required
                >
                  I am a Visa Holder
                </CheckableButton>
              </ButtonContainer>

              {/* Visa Application Number */}
              <div
                id="visaArea"
                style={{
                  display: this.state.displayVisaType ? "block" : "none",
                }}
              >
                <FormField
                  label="Visa Application Number"
                  id="visa_application_number"
                  name="visa_application_number"
                  onChange={this.props.handleFormFieldChange}
                  value={this.props.state.visa_application_number}
                  required={this.state.displayVisaType}
                  placeholder="Visa Grant Number"
                />

                {/* type of visa */}
                <FormDropdown
                  label="Type of Visa"
                  id="visa_type"
                  name="visa_type"
                  value={this.props.state.visa_type || ""}
                  onChange={this.handleddlChange}
                  required={this.state.displayVisaType}
                >
                  <option disabled value="">
                    Please Select
                  </option>
                  <option disabled value="">
                    Family and Partner Visas
                  </option>
                  <option>Carer visa (subclass 836)</option>
                  <option>Carer visa (subclass 116)</option>
                  <option>Global Talent visa (subclass 858)</option>
                  <option>
                    New Zealand Citizen Family Relationship (temporary) visa
                    (subclass 461)
                  </option>
                  <option>Parent visa (subclass 103)</option>
                  <option>
                    Partner (Provisional and Migrant) visa (subclass 309 100)
                  </option>
                  <option>Partner visa (subclass 820 801)</option>
                  <option>Prospective Marriage visa (subclass 300)</option>
                  <option>Remaining Relative visa (subclass 115)</option>
                  <option>Remaining Relative visa (subclass 835)</option>
                  <option>
                    Sponsored Parent (Temporary) visa (subclass 870)
                  </option>
                  <option disabled value="">
                    Visitor Visas
                  </option>
                  <option>Work and Holiday visa (subclass 462)</option>
                  <option>Working Holiday visa (subclass 417)</option>
                  <option disabled value="">
                    Studying and Training Visas
                  </option>
                  <option>Student visa (subclass 500)</option>
                  <option>Student Guardian visa (subclass 590)</option>
                  <option>Training visa (subclass 407)</option>
                  <option disabled value="">
                    Working and Skilled Visas
                  </option>
                  <option>
                    Permanent Residence (Skilled Regional) visa (subclass 191)
                  </option>
                  <option>
                    Regional Sponsored Migration Scheme (subclass 187)
                  </option>
                  <option>
                    Skilled Employer Sponsored Regional (provisional) visa
                    (subclass 494)
                  </option>
                  <option>Skilled Independent visa (subclass 189)</option>
                  <option>Skilled Nominated visa (subclass 190)</option>
                  <option>
                    Skilled-Recognised Graduate visa (subclass 476)
                  </option>
                  <option>
                    Skilled Regional (provisional) visa (subclass 489)
                  </option>
                  <option>Skilled Regional visa (subclass 887)</option>
                  <option>
                    Skilled Work Regional (Provisional) visa (subclass 491)
                  </option>
                  <option>Temporary Activity visa (subclass 408)</option>
                  <option>Temporary Graduate visa (subclass 485)</option>
                  <option>
                    Temporary Work (Short Stay Specialist) visa (subclass 400)
                  </option>
                  <option>Temporary Skill Shortage visa (subclass 482)</option>
                  <option value="Other"> Other Visa</option>
                </FormDropdown>

                {/* other visa specify */}
                <div
                  className="form-group mb-3"
                  id="txtOther"
                  style={{
                    display: this.state.displayOther ? "block" : "none",
                  }}
                  disabled={!this.state.displayOther}
                >
                  <FormField
                    label="Please specify the visa"
                    value={
                      this.state.visa_type !== null ? this.state.visa_type : ""
                    }
                    id="visa_type_other"
                    name="visa_type"
                    onChange={this.props.handleFormFieldChange}
                    required={this.state.displayOther}
                    placeholder="Specify your visa"
                  />
                </div>

                {/* Issuing Office */}
                <FormDropdown
                  label="Issuing Country"
                  id="issuing_office"
                  name="issuing_office"
                  onChange={this.props.handleFormFieldChange}
                  value={
                    this.state.issuing_office_options.includes(
                      this.props.state.issuing_office
                    )
                      ? this.props.state.issuing_office
                      : ""
                  }
                  required={this.state.displayVisaType}
                >
                  <option disabled value="">
                    Please Select
                  </option>
                  {this.state.issuing_office_options.map((place) => {
                    return <option key={place}>{place}</option>;
                  })}
                </FormDropdown>

                {/* visa expiry date */}
                <FormDatePicker
                  label="Visa Expiry Date"
                  id="visa_expiry"
                  selected={this.props.state.visa_expiry}
                  placeholderText={new Date()
                    .toLocaleDateString()
                    .split(/\//)
                    .join("-")}
                  showYearDropdown
                  showMonthDropdown
                  isClearable
                  showPopperArrow={false}
                  minDate={addDays(new Date(), 0)}
                  dropdownMode="select"
                  dateFormatCalendar="MMMM"
                  dateFormat="dd-MM-yyyy"
                  yearDropdownItemNumber={10}
                  scrollableYearDropdown
                  onChange={this.props.handleDateChange}
                  required
                />

                {/* visa upload */}
                <FormField
                  label="Upload Visa"
                  id="flVisa"
                  name="userVisaDoc"
                  disabled
                  placeholder={
                    this.props.state.visa_filename
                      ? this.props.state.visa_filename
                      : "Attach a copy of your visa in PDF format"
                  }
                  header={
                    <>{this.props.state.visa_verification_status ? (
                      <HoverIcon
                        icon="check circle"
                        color="green"
                        type="success"
                        text="This document has been verified!"
                      />
                    ) : (
                      <HoverIcon
                        icon="check circle"
                        color="grey"
                        text="This document has not been verified yet!"
                      />
                    )}
                      <HoverIcon
                        icon="info circle"
                        color="grey"
                        text="Please upload a file less than 600KB."
                      />
                    </>
                  }
                  sideButton={{
                    label: "Upload",
                    id: "btnUpload_visa",
                    type: "button",
                    onClick: () => this.uploadDocument("visa"),
                    disabled: this.props.state.visa_url || this.state.isLoading,
                  }}
                  footer={
                    this.props.state.visa_filename ? (
                      <div className="text-left d-flex">
                        {/* <Link
                          to={{
                            pathname: `/pdfViewer?id=${this.state.visa_url}`,
                          }}
                          target="_blank"
                        >
                          <p className="uploaded-file-name mt-1 ml-1">
                            {this.props.state.visa_filename}
                          </p>
                        </Link> */}
                        <a href={`/NavigateToFileViewer?fileurl=${this.props.state.visa_url}`} target='_blank'>
                          <p className="uploaded-file-name mt-1 ml-1">
                            {this.props.state.visa_filename}
                          </p>
                        </a>
                        <i
                          className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                          onClick={() =>
                            this.setState({
                              deletevisaPopup: true,
                            })
                          }
                        ></i>
                        {this.state.deletevisaPopup && (
                          <DeletePopup
                            togglePopup={(isDelete) =>
                              this.deleteFile(isDelete, "visa", false)
                            }
                          />
                        )}
                      </div>
                    ) : (
                      ""
                    )
                  }
                >
                  {
                    this.state.isLoading && (
                      <CircularProgress />
                    )
                  }
                  <input
                    type="file"
                    id="visa"
                    name="visa"
                    onChange={() => this.handleVisaFileChange()}
                    ref={(ref) => {
                      this.uploadVisa = ref;
                    }}
                    style={{ display: "none" }}
                    accept=".pdf"
                  />
                </FormField>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
//Map root state to this component
const mapStateToProps = function (state) {
  return {
    user: state.user.user,
  };
};

export default connect(mapStateToProps)(VisaForm2);
